import { Container, Col, Row } from "reactstrap";
import * as KeyQL from "queries/key";
import { Link } from "react-router-dom";
import { List } from "@repoflow/components/list-cursor";
import KeySchema from "@common/schema/key/public";
import * as Section from "@repoflow/components/section";

export const Sidebar = () => null;

export const Indice = () => null;

export const Content = ({ match: { params } }) => {
  const { base } = Section.useSectionContext();

  return (
    <Container>
      <div className="mt-4"></div>

      <Row>
        <Col>
          <Link className={"btn btn-primary"} to={`${base}/new`}>
            <i className="fa fa-plus" /> Add
          </Link>
        </Col>
      </Row>

      <div className="mt-4"></div>

      <List
        path={"viewer.account.keys"}
        query={KeyQL.list}
        variables={params}
        schema={KeySchema}
        target={{ $ref: "/Public/Key" }}
        empty={"No API keys yet."}
        config={{
          "/Public/Key": {
            fields: ["description", "keyId", "siteId", "createdAt"],
          },
        }}
        content={({ item: { keyId } }) => (
          <>
            <Link className={"btn btn-primary"} to={`${base}/${keyId}/`}>
              View
            </Link>{" "}
          </>
        )}
      />
    </Container>
  );
};
